import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import notification from '@app/shared/utils/notification';
import { isFetchBaseQueryError } from '@app/shared/utils/common';
import { HttpStatusCode } from '@app/shared/types/common';
import { Page } from '@app/routes';

export function useApiErrorHandler() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleFetchError = (err: unknown) => {
    if (!isFetchBaseQueryError(err)) {
      handleGeneralError();
      return;
    }

    switch (err.status) {
      case HttpStatusCode.BAD_REQUEST:
        notification.error(t('errors.bad_request'));
        break;
      case HttpStatusCode.UNAUTHORIZED:
        notification.error(t('errors.unauthorized'));
        void navigate(Page.AUTH);
        break;
      case HttpStatusCode.CONFLICT:
        notification.error(t('errors.conflict'));
        break;
      case HttpStatusCode.INTERNAL_SERVER_ERROR:
        notification.error(t('errors.internal_server_error'));
        break;
      default:
        handleGeneralError();
    }
  };

  const handleGeneralError = () => {
    notification.error(t('errors.general'));
  };

  return { handleFetchError };
}
